module.exports = __webpack_public_path__ + "img/121.fc6b3438.png";